import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import signIn from "./helper functions/signIn";
import signOut from "./helper functions/signOut";

export const signInMember = createAsyncThunk("member/signIn", signIn);

export const signOutMember = createAsyncThunk("member/signOutMember", signOut);

const memberInitialState = {
  authToken: "",
  userID: "",
  businessEntityID: "",
  pID: "",
  email: "",
  givenName: "",
  familyName: "",
  displayName: "",
  brands: [],
  dashboardState: "",
  eventID: "",
  activeBrand: {
    ID: "",
    about: "",
    brandName: "",
    logo: "",
    languages: [],
    locations: [],
    category: [],
    mau: "",
    onlineStore: "",
    website: "",
    socialMedia: {},
  },
  visitorData: {
    ID: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    emailID: "",
    gender: "",
    onWhatsapp: "",
    faceData: "",
    dependentList: [],
    isDocVerified: "",
  },
  businessData: {
    name: "",
    logo: "https://dolphinchat-chat.s3.ap-south-1.amazonaws.com/mpsedc/digipass/events1761823051176_1761823053338_Book_My_Show_Logo.png",
    color: "",
    image: "",
    fontFamily: "",
  },
};

export const memberSlice = createSlice({
  name: "member",
  initialState: memberInitialState,
  reducers: {
    setActiveBrand(state, { payload }) {
      state.activeBrand.ID = parseInt(payload.brand_id);
      state.activeBrand.about = payload.about;
      state.activeBrand.brandName = payload.brand_name;
      state.activeBrand.logo = payload.logo;
      state.activeBrand.languages = payload.languages;
      state.activeBrand.locations = payload.audience_location;
      state.activeBrand.category = payload.site_category;
      state.activeBrand.mau = payload.mau;
      state.activeBrand.onlineStore = payload.online_store;
      state.activeBrand.website = payload.website;
      state.activeBrand.socialMedia = payload.social_media_handles;
    },

    setUserName(state, { payload }) {
      state.visitorData.firstName = payload;
    },

    setUserDetails(state, { payload }) {
      sessionStorage.setItem(
        "visitorID",
        payload?.userData[0]?._id || payload?.userData[0]?.ID
      );
      let newVisitorData = {
        ID: payload?.userData[0]?._id || payload?.userData[0]?.ID,
        firstName:
          payload?.userData[0]?.first_name ||
          payload?.userData[0]?.firstName ||
          "",
        lastName:
          payload?.userData[0]?.last_name ||
          payload?.userData[0]?.lastName ||
          "",
        gender: payload?.userData[0]?.gender || "",
        emailID:
          payload?.userData[0]?.email_id || payload?.userData[0]?.emailID,
        faceData: "",
        onWhatsapp: "",
        phoneNumber:
          payload?.userData[0]?.phone_number ||
          payload?.userData[0]?.phoneNumber,
        dependentList: payload?.dependentList || [],
      };

      state.visitorData = newVisitorData;
    },

    setBrands(state, { payload }) {
      state.brands.push(payload);
    },

    setDisplayName(state, { payload }) {
      state.displayName = payload;
    },

    setDashboardState(state, { payload }) {
      state.dashboardState = payload;
    },

    setAccessToken: (state, { payload }) => {
      state.authToken = payload;
    },

    setDependent(state, { payload }) {
      state.visitorData.dependentList.push(payload);
    },

    setBusinessData(state, { payload }) {
      console.log("payload", payload);
    },

    setIsDocVerifiedStatus(state, { payload }) {
      state.visitorData.isDocVerified = payload.is_doc_verified;
    },

    updateVisitorData(state, { payload }) {
      state.visitorData = { ...state.visitorData, ...payload };
    },

    deleteAccessToken: () => {
      localStorage.removeItem("authToken");
      sessionStorage.removeItem("authToken");

      const checkInRoute = [
        "/sign-up",
        "/sign-in",
        "/manual-entry",
        "/resend-notification",
        "/manual-verification",
        "/main-gate-entry-back",
        "/main-gate-entry-front",
        "/add-booking",
      ].filter((item) => window.location.pathname == item);

      if (!Boolean(checkInRoute.length)) {
        window.location.href = "/login";
      } else {
        window.location.href = "/sign-in";
      }

      return memberInitialState;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(signInMember.fulfilled, (_, { payload }) => {
        return payload;
      })
      .addCase(signInMember.rejected, () => {
        localStorage.removeItem("authToken");
        sessionStorage.removeItem("authToken");

        return { ...memberInitialState, authToken: "" };
      })
      .addCase(signOutMember.fulfilled, () => {
        localStorage.removeItem("authToken");
        sessionStorage.removeItem("authToken");
        sessionStorage.removeItem("brandType");
        localStorage.removeItem(
          "dashboardState" + sessionStorage.getItem("activeBrand")
        );
        sessionStorage.removeItem("activeBrand");
        sessionStorage.removeItem("businessEntityID");

        return memberInitialState;
      });
  },
});

export const {
  setDashboardState,
  deleteAccessToken,
  setBrands,
  setActiveBrand,
  setDisplayName,
  setUserName,
  setAccessToken,
  setDependent,
  setUserDetails,
  setBusinessData,
  setIsDocVerifiedStatus,
  updateVisitorData,
} = memberSlice.actions;

export default memberSlice.reducer;
